import * as React from "react";
import { CtrlResizable } from "src/components/tables/TableStore";
import { ColumnPoor } from "src/components/tables/ColumnPoor";
import { observer } from "mobx-react-lite";
import { VerticalAlignMiddleOutlined } from "@ant-design/icons";
import { debounce, DebounceCounter } from "src/common/debounce";
import styles from "./ResizerStd.module.less";
import { getColumnWidth } from "../templates/getColumnWidths";

type PropsResizerStd = {
  column: ColumnPoor;
  store: CtrlResizable;
  minWidth?: number;
  containerRef?: React.RefObject<HTMLDivElement>;
  onDragEnd?: () => void;
};

const debounceCounter: DebounceCounter = {};

export const ResizerStd: React.FC<PropsResizerStd> = observer((props) => {
  const { column, store, minWidth, containerRef, onDragEnd } = props;
  const [dragStartState, setDragStartState] = React.useState<[number, number]>([
    0, 0,
  ]);

  React.useEffect(() => {
    // Устанавливаем ширину только если она ещё не задана
    if (!store.columnWidths[column.key] && containerRef?.current) {
      store.setColumnWidth(column.key, containerRef.current.offsetWidth);
    }
  }, [containerRef?.current]);

  const handleDragStart = (e: React.DragEvent) => {
    const blankDragImg = document.createElement("span");
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setDragImage(blankDragImg, 0, 0);
    setDragStartState([
      e.clientX,
      Number(getColumnWidth(store.columnWidths, column.key) || 0),
    ]);
  };

  const handleDrag = (key: string) => (event: React.DragEvent) => {
    debounce(debounceCounter, 0, () => {
      if (event.clientX !== 0) {
        const [startX, colWStart] = dragStartState;
        const currentWidth = colWStart + (event.clientX - startX);
        const width = minWidth
          ? Math.max(currentWidth, minWidth)
          : currentWidth;
        store.setColumnWidth(key, width);
      }
    });
  };

  return (
    store.resizableColumns && (
      <div
        className={styles.columnResizeHandle}
        role="presentation"
        draggable
        onDragStart={handleDragStart}
        onDrag={handleDrag(column.key)}
        onDragEnd={onDragEnd}
      >
        <VerticalAlignMiddleOutlined className={styles.icon} />
      </div>
    )
  );
});
